import React, { Component } from 'react';
import { withDomains, RESTExecutor } from '../../../lib/domain';
import ErrorWrapper from '../../../lib/error_wrapper';
import { Row, Col, List, Typography, Table, Tag, Collapse, Button, Icon, DatePicker, Select } from 'antd';
import moment from 'moment';
import NetworkSelect from '../../../lib/ui/network_select';
import { overrideHeaderTitle, overrideHeaderBack, defaultDateFormat, formatMoney } from '../../../lib/util';
import FilterFixedInput from '../../../components/filter_fixed_input';
import { BasicHeader } from '../../../components/basic_header';
import { setting_quick_menu } from '../../../util/ui_util';
import CustomDateRangePicker from '../../../components/custom_date_range';
const { Title } = Typography;
const { Panel } = Collapse;

const log_types = ["EXCEPTION", "INFO", "WARNING", "CRITICAL"]
const queryString = require('query-string');

const customPanelStyle = {
    background: '#FFFFFF',
    borderRadius: 6,
    marginBottom: 12,
    border: 0,
    overflow: 'hidden',
};


class CronLogs extends Component {
    constructor(props) {
        super(props)

        this.state = {
            filter_query: {}
        }
        this.list_logs = RESTExecutor.list().config({
            label: 'cron_logs',
            params: {
                per_page: 100
            }
        }).connect(props.domains.logs);

    }

    stateUpdater = ({ stateKey, valueKey, value, appendObj = {}, callback }) => {
        let newData = this.state[stateKey];
        this.has_changed = true;
        if (valueKey) {
            newData[valueKey] = value;
        }
        if (appendObj) {
            Object.assign(newData, appendObj)
        }
        console.log(newData);
        this.setState({
            [stateKey]: newData
        }, () => {
            typeof callback === 'function' && callback()
        })
    }

    getParams = () => {
        let params = JSON.parse(JSON.stringify(this.state.filter_query));

        return params;
    }



    render() {
        let list_logs_resp = this.list_logs.response();
        let list_logs_data = list_logs_resp.result || {};
        let rowsData = list_logs_data.rows || [];
        let rowsMeta = list_logs_resp.meta || {};
        const { filter_query } = this.state;

        return (
            <div>
                <BasicHeader
                    no_back
                    title="Cron Logs"
                    menu_items={setting_quick_menu}
                />
                <div className='filter-card'>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        // justifyContent: 'space-between',
                        flexWrap: 'wrap',
                        paddingTop: 4, paddingBottom: 4
                    }}>
                        {/* <FilterFixedInput label="Date From">
                            <DatePicker
                                placeholder="From"
                                style={{
                                }}
                                value={filter_query.from ? moment(filter_query.from, "YYYY-MM-DD") : null}
                                allowClear
                                onChange={(date, dateString) => {
                                    this.stateUpdater({
                                        stateKey: 'filter_query',
                                        valueKey: 'from',
                                        value: date ? dateString : null,
                                        callback: () => {
                                            this.props.history.push({
                                                search: queryString.stringify({ ...this.state.filter_query, per_page: 100, page: 1 })
                                            })
                                            // this.list_logs.config({
                                            //     params: {
                                            //         ...this.getParams()
                                            //     }
                                            // }).execute()
                                        }
                                    })
                                    console.log("DATE", date, dateString);

                                }}
                                // defaultValue={moment('2015/01/01', 'YYYY/MM/DD')} 
                                format={'YYYY-MM-DD'}
                            />
                        </FilterFixedInput>
                        <FilterFixedInput label="Date To">
                            <DatePicker
                                placeholder="To"
                                style={{
                                }}
                                value={filter_query.to ? moment(filter_query.to, "YYYY-MM-DD") : null}
                                allowClear
                                onChange={(date, dateString) => {
                                    this.stateUpdater({
                                        stateKey: 'filter_query',
                                        valueKey: 'to',
                                        value: date ? dateString : null,
                                        callback: () => {
                                            this.props.history.push({
                                                search: queryString.stringify({ ...this.state.filter_query, per_page: 100, page: 1 })
                                            })
                                            // this.list_logs.config({
                                            //     params: {
                                            //         ...this.getParams()
                                            //     }
                                            // }).execute()
                                        }
                                    })
                                    console.log("DATE", date, dateString);

                                }}
                                // defaultValue={moment('2015/01/01', 'YYYY/MM/DD')} 
                                format={'YYYY-MM-DD'}
                            />
                        </FilterFixedInput>
                         */}
                        <FilterFixedInput label="Plugin">
                            <NetworkSelect
                                value={filter_query.plugin_id}
                                item={{ name: "Plugin", className: filter_query.plugin_id != null ? 'filter-option-selected' : '' }}
                                url={'/cron-jobs'}
                                onChange={(received_value) => {
                                    this.stateUpdater({
                                        stateKey: 'filter_query',
                                        valueKey: 'plugin_id',
                                        value: received_value,
                                        callback: () => {
                                            this.props.history.push({
                                                search: queryString.stringify({ ...this.state.filter_query, per_page: 100, page: 1 })
                                            })
                                            // this.list_logs.config({
                                            //     params: {
                                            //         ...this.getParams()
                                            //     }
                                            // }).execute()
                                        }
                                    })
                                    // this._change(item.index, received_value, d_key)
                                }}
                            />
                        </FilterFixedInput>
                        <FilterFixedInput label="Date Range">
                            <CustomDateRangePicker
                            
                                style={{
                                    // width: 400,
                                    // marginLeft: 16,
                                    flex: null
                                }}
                                startDate={filter_query.dateFrom?moment(filter_query.dateFrom, defaultDateFormat):null}
                                endDate={filter_query.dateTo?moment(filter_query.dateTo, defaultDateFormat):null}
                                onChange={(dates) => {
                                    //   console.log("GOT DATES",dates.startDate.toISOString(),dates.endDate.toISOString())
                                    this.stateUpdater({
                                        stateKey: 'filter_query', appendObj: {
                                            dateFrom: dates.startDate?dates.startDate.format(defaultDateFormat):null,
                                            dateTo: dates.endDate?dates.endDate.format(defaultDateFormat):null,
                                            per_page: 100, page: 1
                                        },
                                        callback: () => {
                                            this.props.history.push({
                                                search: queryString.stringify(this.state.filter_query)
                                            })
                                        }
                                    })
                                }}

                            />
                            </FilterFixedInput>
                    </div></div>
                <ErrorWrapper
                    error={list_logs_resp}
                    onReload={() => {
                        this.list_logs.execute()
                    }}>

                    <div className='default-card' style={{ padding: 0 }}>
                        <Table
                            scroll={{ x: true }}
                            // rowClassName='hand-cursor'
                            className='main-table'
                            loading={list_logs_resp.fetching}
                            size='small'
                            rowClassName={(record) => `${record.success ? 'INFO' : 'EXCEPTION'}-ROW`}
                            pagination={{
                                position: 'bottom',
                                onChange: (current, size) => {
                                    this.props.history.push({
                                        // pathname:"users",
                                        search: queryString.stringify({ ...this.state.filter_query, per_page: size, page: current })
                                    })
                                    // this.list_logs.config({
                                    //     params: {
                                    //         per_page: size,
                                    //         page: current
                                    //     }
                                    // }).execute();
                                },
                                defaultCurrent: 1,
                                current: rowsMeta.pagination && parseInt(rowsMeta.pagination.split('/')[0]),
                                // defaultPageSize: 20,
                                pageSize: (rowsMeta && rowsMeta.requested_count),

                                total: (rowsMeta && rowsMeta.total_count > 10000 ? 10000 : rowsMeta.total_count),
                                showTotal: (total, range) => `${formatMoney(range[0],0)}-${formatMoney(range[1],0)} of ${rowsMeta.total_count > 10000 ? `10,000+` : formatMoney(rowsMeta.total_count,0)} items`
                            }}
                            // bordered={false}
                            rowKey={(record) => record.id}
                            expandedRowRender={(record) => {
                                return <div>
                                    <p className={`log-text ${record.success ? 'INFO' : 'EXCEPTION'}-ROW`}>
                                        {record.message}
                                    </p>
                                </div>
                            }}
                            columns={[
                                { title: "Completed At", dataIndex: 'completed_at', key: 'completed_at', width: 160 },
                                { title: 'Config', dataIndex: 'config_id', key: 'config_id', },
                                { title: "Plugin", dataIndex: 'plugin_id', key: 'plugin_id' },
                                { title: "Exception", dataIndex: 'is_exception', key: 'is_exception', render: (text) => `${text}`, width: 78 },
                                { title: "Success", dataIndex: 'success', key: 'success', render: (text) => `${text}`, width: 100 }


                                // { title: "Description", dataIndex: 'message', key: 'message',className:'log-text' }
                            ]}
                            dataSource={rowsData}
                            scroll={{ x: true }}
                        />
                    </div>
                </ErrorWrapper>
            </div>
        );
    }

    componentDidMount() {
        // this.list_logs.execute();
        overrideHeaderTitle("Cron Logs");
        overrideHeaderBack(null);
        let new_filter_query = {};
        if (this.props.location && this.props.location.search) {
            const parsed = queryString.parse(this.props.location.search);
            new_filter_query = parsed;
        }
        this.setState({
            filter_query: {
                per_page: 100,
                page: 1,
                ...new_filter_query
            }
        }, () => {
            this.list_logs.config({
                params: {
                    ...this.getParams()
                }
            }).execute()
        })

    }
    componentWillReceiveProps(nextProps) {

        let new_filter_query = {};
        if (nextProps.location && nextProps.location.search && (this.props.location.search !== nextProps.location.search)) {
            const parsed = queryString.parse(nextProps.location.search);
            new_filter_query = parsed;
            this.setState({
                filter_query: {
                    per_page: 100,
                    page: 1,
                    ...new_filter_query
                }
            }, () => {
                this.list_logs.config({
                    params: {
                        ...this.getParams()
                    }
                }).execute()
            })
        } else {
            // this.list_logs.execute()
        }


    }
}

export default withDomains(CronLogs, 'logs');
